import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AuctionPageDashboard from "../AuctionPageDashboard";
import BiddingConsumer from "./BiddingConsumer";
import BiddingGenerator from "./BiddingGenerator";
import {
  auctionBidders,
  auctionGet,
  tenderSpecefic,
} from "../../../../../Redux/Slices/auctionSlice";
import { useLocation } from "react-router-dom";

const Bidding = () => {
  const location = useLocation();
  let tenderId = location?.search?.split("=")[1];
  console.debug("location", tenderId);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();
  const dispatch = useDispatch();

  useEffect(() => {
    getAuction();
  }, []);

  const getAuction = () => {
    dispatch(tenderSpecefic(tenderId));
  };
  return (
    <>
      {role === "consumer" ? (
        <BiddingConsumer type={"CB"} />
      ) : role === "generator" ? (
        <BiddingGenerator type={"CB"} />
      ) : (
        <AuctionPageDashboard />
      )}
    </>
  );
};

export default Bidding;
